import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import { i18n } from '@/plugins/i18n';
import isMobileWidth from '@/helpers/isMobile';
import { ROUTES } from '@/helpers/constants';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            meta: {
                required: true,
            },
            redirect: {
                name: 'Order',
            },
        },
        {
            path: '/',
            meta: {
                required: true,
            },
            redirect: {
                name: 'Order',
            },
        },
        {
            path: '/login',
            meta: {
                required: true,
            },
            redirect: {
                name: 'Order',
            },
        },
        {
            path: '/tasks',
            component: () => import('./components/tasks/Index'),
            children: [
                {
                    path: '',
                    name: 'Task',
                    component: () => import('./components/tasks/List'),
                    meta: {
                        title: 'taskList',
                        icon: 'menu',
                        menuTitle: 'tasks',
                    },
                },
                {
                    path: ':taskId',
                    name: 'TaskView',
                    component: () => import('./components/tasks/View'),
                    meta: {
                        title: 'taskView',
                        required: true,
                    },
                },
            ],
        },
        {
            path: '/orders',
            component: () => import('./components/orders/Index'),
            children: [
                {
                    path: '',
                    name: 'Order',
                    component: () => import('./components/orders/list/Index'),
                    meta: {
                        title: 'orderList',
                        icon: 'file',
                        menuTitle: 'orders',
                    },
                },
                // TEST
                {
                    path: 'test',
                    name: 'OrderTest',
                    component: () => import('./components/orders/test/Test'),
                    meta: {
                        title: 'orderTest',
                    },
                },
                {
                    path: 'logs/:orderId',
                    name: 'OrderLogs',
                    component: () => import('./components/logs/OrderLog'),
                    meta: {
                        menuTitle: 'Лог статуса заказа',
                    },
                },
                {
                    path: ':orderId',
                    name: 'OrderView',
                    component: () => import('./components/orders/View'),
                    meta: {
                        title: 'orderView',
                    },
                },
            ],
        },
        {
            path: '/refunds',
            component: () => import('./components/refund/Index'),
            children: [
                {
                    path: '',
                    redirect: {
                        name: 'RefundIndex',
                    },
                },
                {
                    path: 'list',
                    name: 'RefundList',
                    component: () => import('./components/refund/List'),
                    meta: {
                        title: 'refundList',
                        menuTitle: 'refund',
                    },
                },
                {
                    path: 'yandex',
                    name: 'RefundYandex',
                    component: () => import('./components/refund/yandex/Index'),
                    meta: {
                        title: 'refundYandex',
                        menuTitle: 'refundYandex',
                    },
                },
                {
                    path: 'partners',
                    name: 'RefundPartners',
                    component: () => import('./components/refund/Partners'),
                    meta: {
                        title: 'partners',
                        menuTitle: 'partners',
                    },
                },
                {
                    path: ':refundId(\\d+)',
                    name: 'RefundDetails',
                    component: () => import('./components/refund/details/Index'),
                    props: true,
                    meta: {
                        title: 'refundIndex',
                    },
                },
                {
                    path: 'check',
                    name: 'RefundCheck',
                    component: () => import('./components/refund/Check'),
                    meta: {
                        title: 'refundCheck',
                        menuTitle: 'refund',
                    },
                },
                {
                    path: ':orderId/create',
                    name: 'RefundCreate',
                    component: () => import('./components/refund/create/Create'),
                    meta: {
                        title: 'refundCreate',
                        menuTitle: 'refundCheck',
                    },
                },
                {
                    path: 'return-from-kuper-vitrina',
                    name: 'ReturnFromKuperVitrina',
                    component: () => import('./components/refund/return-from-shipping/ReturnFromKuperVitrina'),
                    meta: {
                        title: 'returnFromKuperVitrina',
                        titleMobile: 'refundIndex',
                        menuTitle: 'returnFromKuperVitrina',
                        icon: 'sync',
                    },
                },
                {
                    path: 'return-from-shipping',
                    component: () => import('./components/refund/return-from-shipping/Index'),
                    children: [
                        {
                            path: '',
                            redirect: {
                                name: 'RefundIndex',
                            },
                        },
                        {
                            path: 'actual',
                            name: 'RefundIndex',
                            component: () => import('./components/refund/return-from-shipping/Actual'),
                            meta: {
                                title: 'actualReturn',
                                h1: 'actualReturn',
                                menuTitle: 'refund',
                                icon: 'sync',
                            },
                        },
                        {
                            path: 'no-actual',
                            name: 'NoActualReturnFromShipping',
                            component: () => import('./components/refund/return-from-shipping/NoActual'),
                            meta: {
                                title: 'actualReturn',
                                h1: 'actualReturn',
                                menuTitle: 'refundIndex',
                            },
                        },
                        {
                            path: ':service',
                            name: 'ReturnFromShippingService',
                            component: () => import('./components/refund/return-from-shipping/Service'),
                            meta: {
                                title: 'returnFromShipping',
                                menuTitle: 'refundIndex',
                            },
                        },
                    ],
                },
                {
                    path: '/exchanges',
                    component: () => import('./components/exchanges/Index'),
                    children: [
                        {
                            path: '',
                            redirect: {
                                name: 'ExchangeIndex',
                            },
                        },
                        {
                            path: 'check',
                            name: 'ExchangeIndex',
                            component: () => import('./components/exchanges/create/Index'),
                            meta: {
                                icon: 'sort',
                                title: 'exchangeIndex',
                                menuTitle: 'refund',
                            },
                        },
                        {
                            path: ':orderId/create',
                            name: 'ExchangeCreate',
                            component: () => import('./components/exchanges/create/Create'),
                            meta: {
                                title: 'exchangeCreate',
                                menuTitle: 'exchangeCheck',
                            },
                        },
                        {
                            path: ':id/view',
                            name: 'ExchangeView',
                            component: () => import('./components/exchanges/view/View'),
                        },
                        {
                            path: 'list',
                            name: 'ExchangeList',
                            component: () => import('./components/exchanges/List'),
                            meta: {
                                title: 'exchangeList',
                                menuTitle: 'exchangeList',
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: '/settings',
            component: () => import('./components/settings/Index'),
            children: [
                {
                    path: '',
                    name: 'Setting',
                    component: () => import('./components/settings/Main'),
                    meta: {
                        title: 'settingMain',
                        icon: 'sliders',
                        menuTitle: 'settings',
                    },
                },
                {
                    path: 'order-change-status',
                    name: 'SettingOrderChangeStatus',
                    component: () => import('./components/settings/OrderChangeStatus'),
                    meta: {
                        title: 'settingOrderChangeStatus',
                        menuTitle: 'settingOrderChangeStatus',
                    },
                },
                {
                    path: 'external-services',
                    name: 'SettingExternalService',
                    component: () => import('./components/settings/ExternalService'),
                    meta: {
                        title: 'settingExternalService',
                        menuTitle: 'settingExternalService',
                    },
                },
                {
                    path: 'permissions',
                    name: 'SettingPermission',
                    component: () => import('./components/settings/roles/permissions/Permission'),
                    meta: {
                        title: 'settingPermission',
                        menuTitle: 'settingPermission',
                    },
                },
                {
                    path: 'roles',
                    component: () => import('./components/settings/roles/Index'),
                    children: [
                        {
                            path: '',
                            name: 'SettingRoleIndex',
                            component: () => import('./components/settings/roles/Main'),
                            meta: {
                                title: 'settingRoleMain',
                                menuTitle: 'settingRole',
                            },
                        },
                        {
                            path: 'order-statuses',
                            name: 'SettingRoleOrderStatus',
                            component: () => import('./components/settings/roles/OrderStatus'),
                            meta: {
                                title: 'settingRoleOrderStatus',
                                menuTitle: 'settingRoleOrderStatus',
                            },
                        },
                    ],
                },
                {
                    path: 'ui',
                    component: () => import('./components/settings/ui/Index'),
                    children: [
                        {
                            path: '',
                            name: 'SettingUIIndex',
                            component: () => import('./components/settings/ui/Priority'),
                            meta: {
                                title: 'settingUIPriority',
                            },
                        },
                        {
                            path: 'expired',
                            name: 'SettingUIExpired',
                            component: () => import('./components/settings/ui/Expired'),
                            meta: {
                                title: 'settingUIPriority',
                            },
                        },
                    ],
                },
                {
                    path: 'reference',
                    name: 'SettingReferenceIndex',
                    component: () => import('./components/settings/reference/Index'),
                    meta: {
                        title: 'settingReferenceIndex',
                    },
                },
                {
                    path: 'alerts',
                    name: 'SettingAlertsIndex',
                    component: () => import('./components/settings/alerts/Index'),
                    meta: {
                        title: 'settingAlertsIndex',
                    },
                },
                {
                    path: 'mailing',
                    name: 'MailingList',
                    component: () => import('./components/settings/mailing/Index'),
                    meta: {
                        title: 'settingMailingList',
                        menuTitle: 'settingMailingList',
                    },
                },
                {
                    path: 'events',
                    name: 'EventList',
                    component: () => import('./components/settings/events/EventList'),
                    meta: {
                        title: 'settingEventList',
                        menuTitle: 'settingEventList',
                    },
                },
                {
                    path: 'sap',
                    name: 'SapIndex',
                    component: () => import('./components/settings/sap/Index'),
                    meta: {
                        title: 'settingSap',
                        menuTitle: 'settingSap',
                    },
                },
                {
                    path: 'sap/batch',
                    name: 'SapBatchIndex',
                    component: () => import('./components/settings/sap/batch/Index'),
                    meta: {
                        title: 'settingSapBatch',
                    },
                },
                {
                    path: 'sap/batch/:id',
                    name: 'SapBatchTaskDetails',
                    component: () => import('./components/settings/sap/batch/TaskDetails'),
                    props: true,
                    meta: {
                        title: 'settingSapBatchTaskDetail',
                    },
                },
                {
                    path: 'acceptance-acts',
                    name: 'AcceptanceActList',
                    component: () => import('./components/settings/acceptance-acts/AcceptanceActList'),
                    meta: {
                        title: 'settingAcceptanceActList',
                        menuTitle: 'settingAcceptanceActList',
                    },
                },
                {
                    path: 'checks',
                    name: 'CheckIndex',
                    component: () => import('./components/settings/CheckIndex'),
                    meta: {
                        title: 'settingCheck',
                    },
                    children: [
                        {
                            path: 'atol',
                            name: 'AtolIndex',
                            component: () => import('./components/settings/atol/Index'),
                            meta: {
                                title: 'settingAtol',
                                menuTitle: 'settingAtol',
                            },
                        },
                        {
                            path: 'set-kit',
                            name: 'SetKitIndex',
                            component: () => import('./components/settings/set-kit/Index'),
                            meta: {
                                title: 'settingSetKit',
                                menuTitle: 'settingSetKit',
                            },
                        },
                    ],
                },
                {
                    path: 'distribution',
                    name: 'DistributionIndex',
                    component: () => import('./components/settings/distribution/Index'),
                    meta: {
                        title: 'settingDistribution',
                        menuTitle: 'settingDistribution',
                    },
                },
                {
                    path: 'distribution/other-pfm/manage',
                    name: 'PfmManage',
                    component: () => import('./components/settings/distribution/Index'),
                    meta: {
                        title: 'settingDistribution',
                        menuTitle: 'settingDistribution',
                    },
                },
                {
                    path: 'distribution/other-pfm/select',
                    name: 'PfmSelect',
                    component: () => import('./components/settings/distribution/Index'),
                    meta: {
                        title: 'settingDistribution',
                        menuTitle: 'settingDistribution',
                    },
                },
                {
                    path: 'tracknum-search',
                    component: () => import('./components/settings/tracknum-search/Index'),
                    children: [
                        {
                            path: '',
                            name: 'TracknumSearchIndex',
                            component: () => import('./components/settings/tracknum-search/TracknumSearch'),
                            meta: {
                                title: 'tracknumSearchIndex',
                                menuTitle: 'tracknumSearchIndex',
                            },
                        },
                        {
                            path: ':id',
                            name: 'TracknumSearchCard',
                            component: () => import('./components/settings/tracknum-search/OrderCard'),
                            meta: {
                                title: 'tracknumSearchIndex',
                            },
                        },
                    ],
                },
                {
                    path: 'reports',
                    name: 'ReportsIndex',
                    component: () => import('./components/settings/reports/Index'),
                    meta: {
                        title: 'settingReports',
                        menuTitle: 'settingReports',
                    },
                },
            ],
        },
        {
            path: '/issue-delivery',
            component: () => import('./components/issueDelivery/Index'),
            children: [
                {
                    path: '',
                    redirect: {
                        name: 'ActualIssueDelivery',
                    },
                },
                {
                    path: 'actual',
                    name: 'ActualIssueDelivery',
                    component: () => import('./components/issueDelivery/Actual'),
                    meta: {
                        icon: 'truck',
                        title: 'issue',
                        menuTitle: 'issue',
                    },
                },
                {
                    path: 'actual/:service',
                    name: 'ActualIssueDeliveryView',
                    component: () => import('./components/issueDelivery/View'),
                    meta: {
                        title: 'actualIssueDeliveryView',
                    },
                },
                {
                    path: 'no-actual',
                    name: 'NoActualIssueDelivery',
                    component: () => import('./components/issueDelivery/NoActual'),
                    meta: {
                        title: 'noActualIssueDelivery',
                    },
                },
            ],
        },
        {
            path: '/customers',
            component: () => import('./components/customers/Index'),
            children: [
                {
                    path: '',
                    name: 'Customer',
                    component: () => import('./components/customers/List'),
                    meta: {
                        title: 'customerList',
                        icon: 'users',
                        menuTitle: 'customer',
                    },
                },
                {
                    path: ':phone',
                    name: 'CustomerView',
                    component: () => import('./components/customers/View'),
                    meta: {
                        title: 'customerView',
                    },
                },
            ],
        },
        {
            path: '/feedbacks',
            component: () => import('./components/feedback/Index'),
            children: [
                {
                    path: '',
                    name: 'Feedback',
                    component: () => import('./components/feedback/List'),
                    meta: {
                        title: 'feedbackList',
                        icon: 'message',
                        menuTitle: 'feedback',
                    },
                },
            ],
        },
        {
            path: '*',
            name: 'Error',
            component: () => import('./components/errors/Error.vue'),
            meta: {
                required: true,
            },
        },

        {
            path: ROUTES.AccessDenied.path,
            name: ROUTES.AccessDenied.name,
            component: () => import('./components/errors/AccessDenied/index.vue'),
            meta: {
                required: true,
            },
            beforeEnter: (to, from, next) => {
                if (store.state.access.userHasAccess) {
                    next({ path: ROUTES.Orders.path });
                } else {
                    next();
                }
            },
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    document.title = 'CRM';

    if (!store.getters.menuList.length) {
        await store.dispatch('setMenu', isMobileWidth());
        await store.dispatch('setAccess');
    }

    if (to.matched.some(record => record.meta.required) ||
        store.getters.menuList.findIndex(route => route.matched[0] === to.matched[0]) >= 0) {
        document.title = (to.meta.title ? (i18n.tc(`main.header.${to.meta.title}`, 1) + ' | ') : '') + 'CRM';
        next();
    } else {
        next({ name: 'Error' });
    }
});

export default router;